import { skinsGroupage } from 'modules/journey/card/styled';
const DONE_STATUSES = ['DONE', 'DONE_WITHOUT_MANIFEST', 'CANCELLED'];
const GOOD_ACCURACY = ['HIGH', 'MEDIUM'];

export const getLatLng = ({ position: { lat, lng } }) => {
  return new window.google.maps.LatLng(lat, lng);
};

export const getRouteForNonFinishedStops = (markers) => {
  const origin = getLatLng(markers.find((marker) => !DONE_STATUSES.includes(marker.status)));
  const destination = getLatLng(markers[markers.length - 1]);

  const waypoints = markers
    .map((stop, key) => {
      if (key === 0 || key === markers.length - 1 || DONE_STATUSES.includes(stop.status)) {
        return null;
      }

      return {
        location: getLatLng(stop),
        stopover: true,
      };
    })
    .filter((notnull) => notnull);

  return {
    avoidFerries: true,
    origin,
    destination,
    waypoints,
    optimizeWaypoints: false,
    travelMode: window.google.maps.TravelMode.DRIVING,
  };
};

export const getDriverRouteToNextStop = ({ assignedDriverMarker, stopMarkers }) => {
  const nextStopMarker = stopMarkers.find(
    (stopMarker) => !DONE_STATUSES.includes(stopMarker.status)
  );

  if (!nextStopMarker) return {};

  const { shipment_state_logs } = nextStopMarker;
  const [lastLog] = (shipment_state_logs || []).slice(-1);
  const driverIsInAstop = lastLog && lastLog.state_to && lastLog.state_to.includes('PENDING');

  if (driverIsInAstop) return {};

  const origin = getLatLng(assignedDriverMarker);
  const destination = getLatLng(nextStopMarker);

  return {
    avoidFerries: true,
    origin,
    destination,
    travelMode: window.google.maps.TravelMode.DRIVING,
  };
};

export const getMiddlePosition = (directions) => {
  const [route] = directions.routes;
  const { overview_path } = route;
  const middleRoutePathPositions = overview_path[Math.floor((overview_path.length - 1) / 2)] || {};

  return middleRoutePathPositions;
};

export const getIcon = ({
  address,
  status,
  shipper_order_id,
  shipper_orders_skin,
  colorSchema,
}) => {
  const ICONS = {
    PENDING: {
      ACCURATE: {
        path: 'M9.82544769,0 C15.2507294,0 19.6487892,4.39805982 19.6487892,9.82334156 C19.6487892,11.3679794 19.2845358,12.8908482 18.5856021,14.2683088 L10.9551624,29.3064017 C10.7392601,29.7319026 10.30259,30 9.82544769,30 C9.34830534,30 8.91163529,29.7319026 8.69573298,29.3064017 L1.06529327,14.2683088 C-1.38959435,9.43020911 0.542380753,3.51807476 5.38048045,1.06318713 C6.75794106,0.364253416 8.28080985,0 9.82544769,0 Z M10,8 C8.8954305,8 8,8.8954305 8,10 C8,11.1045695 8.8954305,12 10,12 C11.1045695,12 12,11.1045695 12,10 C12,8.8954305 11.1045695,8 10,8 Z',
        anchor: new window.google.maps.Point(10, 0),
      },
      NO_ACCURATE: {
        path: 'M10,0 C15.5228475,0 20,4.4771525 20,10 C20,15.5228475 15.5228475,20 10,20 C4.4771525,20 0,15.5228475 0,10 C0,4.4771525 4.4771525,0 10,0 Z M10,8 C8.8954305,8 8,8.8954305 8,10 C8,11.1045695 8.8954305,12 10,12 C11.1045695,12 12,11.1045695 12,10 C12,8.8954305 11.1045695,8 10,8 Z',
        anchor: new window.google.maps.Point(10, 10),
      },
    },
    DONE: {
      ACCURATE: {
        path: 'M9.82544769,0 C15.2507294,0 19.6487892,4.39805982 19.6487892,9.82334156 C19.6487892,11.3679794 19.2845358,12.8908482 18.5856021,14.2683088 L10.9551624,29.3064017 C10.7392601,29.7319026 10.30259,30 9.82544769,30 C9.34830534,30 8.91163529,29.7319026 8.69573298,29.3064017 L1.06529327,14.2683088 C-1.38959435,9.43020911 0.542380753,3.51807476 5.38048045,1.06318713 C6.75794106,0.364253416 8.28080985,0 9.82544769,0 Z M14.7935181,6.6532833 C14.4501195,6.42165802 13.9839705,6.5122682 13.7523452,6.85566681 L13.7523452,6.85566681 L9.23621661,13.5511028 L6.1899571,10.3966087 C5.90222018,10.0986484 5.42741877,10.0903607 5.12945847,10.3780977 C4.83149817,10.6658346 4.82321048,11.140636 5.1109474,11.4385963 L5.1109474,11.4385963 L8.75790385,15.2151302 C8.77121436,15.2289137 8.78492517,15.2420772 8.79900026,15.2546203 C8.83545476,15.2927008 8.876506,15.3274967 8.92199258,15.3581778 C9.26539119,15.5898031 9.73154015,15.4991929 9.96316544,15.1557943 L9.96316544,15.1557943 L14.9959016,7.69445616 C15.2275269,7.35105755 15.1369167,6.88490859 14.7935181,6.6532833 Z',
        anchor: new window.google.maps.Point(10, 0),
      },
      NO_ACCURATE: {
        path: 'M10,0 C15.5228475,0 20,4.4771525 20,10 C20,15.5228475 15.5228475,20 10,20 C4.4771525,20 0,15.5228475 0,10 C0,4.4771525 4.4771525,0 10,0 Z M14.7935181,5.6532833 C14.4501195,5.42165802 13.9839705,5.5122682 13.7523452,5.85566681 L13.7523452,5.85566681 L9.23621661,12.5511028 L6.1899571,9.39660873 C5.90222018,9.09864843 5.42741877,9.09036074 5.12945847,9.37809766 C4.83149817,9.66583458 4.82321048,10.140636 5.1109474,10.4385963 L5.1109474,10.4385963 L8.75790385,14.2151302 C8.77121436,14.2289137 8.78492517,14.2420772 8.79900026,14.2546203 C8.83545476,14.2927008 8.876506,14.3274967 8.92199258,14.3581778 C9.26539119,14.5898031 9.73154015,14.4991929 9.96316544,14.1557943 L9.96316544,14.1557943 L14.9959016,6.69445616 C15.2275269,6.35105755 15.1369167,5.88490859 14.7935181,5.6532833 Z',
        anchor: new window.google.maps.Point(10, 10),
      },
    },
  };

  const skin = shipper_orders_skin[shipper_order_id];
  const { accuracy_level = '' } = address || {};

  const stopStatus = DONE_STATUSES.includes(status) ? 'DONE' : 'PENDING';
  const accuracy = GOOD_ACCURACY.includes(accuracy_level) ? 'ACCURATE' : 'NO_ACCURATE';

  const icon = ICONS[stopStatus][accuracy];
  const fillColor = skinsGroupage[skin] ? skinsGroupage[skin] : colorSchema.primary500;

  return {
    ...icon,
    fillOpacity: 1,
    strokeColor: 'white',
    strokeOpacity: 1,
    strokeWeight: 2,
    fillColor,
  };
};
